/**
 * @file paddlex 历史版本表格
 * @author FengGuang(fengguang01@baidu.com)
 */

import React, {useMemo} from 'react';
import {Table} from 'antd';
import { getTextInfo } from './../../../../utils/getTextInfo';
import {IHistoryVersionTableProps} from './types';

const HistoryVersionTable: React.FC<IHistoryVersionTableProps> = props => {
    const dataSource = props.dataSource || [];

    const columns = useMemo(() => {
        return [
            {
                title: '发版日期',
                dataIndex: 'date',
                key: 'date'
            },
            {
                title: '版本号',
                dataIndex: 'version',
                key: 'version'
            },
            {
                title: 'Win版',
                dataIndex: 'winUrl',
                key: 'winUrl',
                render: (html: string) => {
                    const propsObj = getTextInfo(html ?? '');
                    return <span {...propsObj} />
                }
            },
            {
                title: 'Mac版',
                dataIndex: 'macUrl',
                key: 'macUrl',
                render: (html: string) => {
                    const propsObj = getTextInfo(html ?? '');
                    return <span {...propsObj} />
                }
            },
            {
                title: 'Linux版',
                dataIndex: 'linuxUrl',
                key: 'linuxUrl',
                render: (html: string) => {
                    const propsObj = getTextInfo(html ?? '');
                    return <span {...propsObj} />
                }
            },
            {
                title: '更新说明',
                dataIndex: 'releaseNoteUrl',
                key: 'releaseNoteUrl',
                render: (html: string) => {
                    const propsObj = getTextInfo(html ?? '');
                    return <span {...propsObj} />
                }
            }
        ];
    }, []);


    return (
        <div className="paddle-lab-history-version-table">
            <Table
                columns={columns}
                {...props}
                dataSource={dataSource}
            />
        </div>
    );
};

export default HistoryVersionTable;
